const { languages } = require('./environment');
const createPermalinks = require('./createpermalinks');

const normalizeQuality = (quality) => {
  switch (quality) {
    default:
      return undefined;

    case 'vr':
      return 'VR';

    case 'hd':
    case 'hd-full':
      return 'HD';

    case 'sd':
    case 'mobile':
      return 'SD';

    case '4k':
      return '4K';

    case '8k':
      return '8K';
  }
};

const processItem = (item) => {
  item.numericId = item.id;
  item.id = item.itemNumber || item.id;
  item.src = item.src || item.image;
  item.href = item.href || item.url;

  switch (true) {
    default:
      item.moviesHref = languages.reduce((acc, language) => {
        acc[language] = `${item.href[language]}?filter%5Bstreaming_type%5D=movie&show=movie`;

        return acc;
      }, {});
      item.scenesHref = languages.reduce((acc, language) => {
        acc[language] = `${item.href[language]}?filter%5Bstreaming_type%5D=scene&show=scene`;

        return acc;
      }, {});
      break;

    case JSON.stringify(item.href).indexOf('/studio/') > -1:
      item.moviesHref = languages.reduce((acc, language) => {
        const movieOverviewPermalink = createPermalinks.movieoverview(language);

        acc[language] = `${movieOverviewPermalink}?filter[studio][]=${item.id}`;

        return acc;
      }, {});
      item.scenesHref = languages.reduce((acc, language) => {
        const movieOverviewPermalink = createPermalinks.movieoverview(language);

        acc[language] = `${movieOverviewPermalink}?filter[streaming_type]=scene&filter[studio][]=${item.id}`;

        return acc;
      }, {});
      break;

    case JSON.stringify(item.href).indexOf('/pornostar/') > -1 || JSON.stringify(item.href).indexOf('/pornstar/') > -1:
      item.moviesHref = languages.reduce((acc, language) => {
        const movieOverviewPermalink = createPermalinks.movieoverview(language);

        acc[language] = `${movieOverviewPermalink}?filter[pornstar][]=${item.slug[language]}`;

        return acc;
      }, {});
      item.scenesHref = languages.reduce((acc, language) => {
        const movieOverviewPermalink = createPermalinks.movieoverview(language);

        acc[language] = `${movieOverviewPermalink}?filter[streaming_type]=scene&filter[pornstar][]=${item.slug[language]}`;

        return acc;
      }, {});
      break;
  }

  item.quality = normalizeQuality(item.quality);
  item.rating = item.rating ? Math.round(item.rating) : Math.round(item.movie ? item.movie.rating : 5);
  /* eslint-disable no-nested-ternary */
  item.addedTimestampSeconds = item.addedTimestampSeconds ? Number(item.addedTimestampSeconds) : item.movie ? Number(item.movie.addedTimestampSeconds) : undefined;
  item.durationSeconds = Number(item.durationSeconds);

  item.currentPrice = item.currentPrice ? Number(item.currentPrice) : undefined;
  item.regularPrice = item.regularPrice ? Number(item.regularPrice) : undefined;

  if (item.currentPrice === undefined && item.prices && item.prices.self && item.prices.self.buy && item.prices.self.buy.currentPrice !== undefined) {
    item.currentPrice = Number(item.prices.self.buy.currentPrice);
  }
  if (item.currentPrice === undefined && item.prices && item.prices.self && item.prices.self.rent && item.prices.self.rent.currentPrice !== undefined) {
    item.currentPrice = Number(item.prices.self.rent.currentPrice);
  }

  if (item.regularPrice === undefined && item.prices && item.prices.self && item.prices.self.buy && item.prices.self.buy.regularPrice !== undefined) {
    item.regularPrice = Number(item.prices.self.buy.regularPrice);
  }
  if (item.regularPrice === undefined && item.prices && item.prices.self && item.prices.self.rent && item.prices.self.rent.regularPrice !== undefined) {
    item.regularPrice = Number(item.prices.self.rent.regularPrice);
  }

  if (item.prices) {
    [
      'buy',
      'rent',
      'other',
    ].forEach((transactionType) => {
      if (item.prices[transactionType]) {
        [
          'currentPrice',
          'regularPrice',
        ].forEach((priceType) => {
          if (item.prices[transactionType][priceType] !== undefined) {
            item.prices[transactionType][priceType] = Number(item.prices[transactionType][priceType]);
          }
        });
      }
      if (item.prices.self && item.prices.self[transactionType]) {
        [
          'currentPrice',
          'regularPrice',
        ].forEach((priceType) => {
          if (item.prices.self[transactionType][priceType] !== undefined) {
            item.prices.self[transactionType][priceType] = Number(item.prices.self[transactionType][priceType]);
          }
        });
      }
      if (item.prices.other && item.prices.other[transactionType]) {
        [
          'currentPrice',
          'regularPrice',
        ].forEach((priceType) => {
          if (item.prices.other[transactionType][priceType] !== undefined) {
            item.prices.other[transactionType][priceType] = Number(item.prices.other[transactionType][priceType]);
          }
        });
      }
    });
  }

  if (item.movie) {
    item.movie = item.movie || {};
    item.movie.src = item.movie.src || item.movie.image;
  }

  if (item.trailer) {
    item.trailer = item.trailer || {};
    item.trailer.sources = item.trailer.sources ? item.trailer.sources.map((source) => {
      if (!source.src && source.file) {
        source.src = source.file;
      }
      return source;
    }) : undefined;
  }

  return item;
};

module.exports = processItem;



// WEBPACK FOOTER //
// ./src/_utilities/processsearchresults-item.js